import { render } from "./FooterLightfortheworld.vue?vue&type=template&id=a46990a8&scoped=true"
import script from "./FooterLightfortheworld.vue?vue&type=script&lang=js"
export * from "./FooterLightfortheworld.vue?vue&type=script&lang=js"

import "./FooterLightfortheworld.vue?vue&type=style&index=0&id=a46990a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46990a8"]])

export default __exports__